// Provider stanu sesji (lib/session.ts) — owija AppShell, więc obejmuje wszystkie
// trasy w powłoce, a trasy /print zostawia w spokoju. Na start dwa równoległe
// zapytania: /api/auth/me (useMe z lib/auth) i /api/auth/config.

import { useEffect, useMemo, useState, type ReactNode } from 'react'

import { useMe } from '../../lib/auth'
import { fetchAuthConfig, SessionContext, type AuthConfig, type SessionState } from '../../lib/session'

export function SessionProvider({ children }: { children: ReactNode }) {
  const { me, loading, error, setMe, reload } = useMe()
  const [config, setConfig] = useState<AuthConfig | null>(null)

  useEffect(() => {
    let alive = true
    fetchAuthConfig().then((c) => { if (alive) setConfig(c) })
    return () => { alive = false }
  }, [])

  const value = useMemo<SessionState>(
    () => ({ me, loading, error, setMe, reload, config, authRequired: config?.auth_required === true }),
    [me, loading, error, setMe, reload, config],
  )
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
}
